import React from 'react';
import { 
  Paper, 
  BottomNavigation as MuiBottomNavigation, 
  BottomNavigationAction 
} from '@mui/material';
import { 
  Home as HomeIcon,
  LocationOn as MapIcon,
  Inventory as AssetsIcon,
  Notifications as AlertsIcon,
  Person as ProfileIcon
} from '@mui/icons-material';

const BottomNavigation = ({ value, onChange }) => {
  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        boxShadow: 3
      }} 
      elevation={3}
    >
      <MuiBottomNavigation
        showLabels
        value={value}
        onChange={onChange}
      >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} />
        <BottomNavigationAction label="Map" icon={<MapIcon />} />
        <BottomNavigationAction label="Assets" icon={<AssetsIcon />} />
        <BottomNavigationAction label="Alerts" icon={<AlertsIcon />} />
        <BottomNavigationAction label="Profile" icon={<ProfileIcon />} />
      </MuiBottomNavigation>
    </Paper>
  );
};

export default BottomNavigation;
